/**
 * NProgress Component
 */

import './styles.scss';

import { random } from 'lodash';
import * as nextTick from 'next-tick';
import * as nprogress from 'nprogress';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

interface IOwnProps {
  active: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const classes = new BEM('nprogress-wrapper');

export default class NProgress extends React.Component<IOwnProps, {}> {
  private didMount = false;

  constructor(props: IOwnProps) {
    super(props);
  }

  configure() {
    nprogress.configure({
      minimum: random(.3, .6),
      parent: '.nprogress-wrapper',
      showSpinner: false,
      trickleSpeed: 100,
    });
  }

  start() {
    this.configure();
    nprogress.start();
  }

  done() {
    nprogress.done();
  }

  componentDidMount() {
    this.didMount = true;
    if (this.props.active) {
      this.start();
    }
  }

  // componentWillReceiveProps(nextProps: IOwnProps) {
  //   if (nextProps.active && !this.props.active) {
  //     nextTick(() => {
  //       if (this.didMount) {
  //         this.configure();
  //         nprogress.start();
  //       }
  //     });
  //   } else if (!nextProps.active && this.props.active) {
  //     nextTick(() => {
  //       if (this.didMount) {
  //         nprogress.done();
  //       }
  //     });
  //   }
  // }

  componentDidUpdate(prevProps: IOwnProps, prevState) {
    if (!prevProps.active && this.props.active) {
      nextTick(() => {
        if (this.didMount) {
          this.start();
        }
      });
    } else if (prevProps.active && !this.props.active) {
      nextTick(() => {
        if (this.didMount) {
          this.done();
        }
      });
    }
  }

  componentWillUnmount() {
    this.didMount = false;
    nprogress.remove();
  }

  render() {
    return <div {...classes('', '', this.props.className) } style={this.props.style} />;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/feedback/NProgress/index.tsx